<template>
  <div class="invoicerow"> 
    <div class="column">
      <user-icon size="1.5x" class="custom-class"></user-icon>
      <p class="user" :title="name">{{ name }}</p>
    </div>
    <div v-if="!isMobile()" class="column date">
      <calendar-icon size="1.5x" class="custom-class"></calendar-icon>
      <p>{{ humanTime(ctime) }}</p>
    </div>
    <div v-if="name === emailAdmin && !isMobile()" class="column revoke">
      <span class="admin">{{ $t('settings.administrator') }}</span>
    </div>
    <div v-else-if="isAdmin && !isMobile()" class="column revoke">
      <button class="button button-create" :title="$t('settings.revokeAccess')" @click="revocarAcceso(handle)">
        <span>{{ $t('settings.revokeAccess') }}</span>
      </button>

      <select v-on:change="changePermissions" v-model="permissions">
        <option :value=0>{{ $t('settings.editor') }}</option>
        <option :value=1>{{ $t('settings.reader') }}</option>
      </select>
    </div>
    <div v-else-if="!isAdmin && !isMobile()" class="column revoke">
      <button class="button button-create" :title="$t('settings.revokeAccessAccount')" @click="revocarAccesoCuenta()">
        <span>{{ $t('settings.revokeAccessAccount') }}</span>
      </button>
    </div>
    <div v-if="isMobile()" class="column info">
      <button @click="isShow = true" :aria-label="$t('buttons.moreInformation')" :title="$t('buttons.moreInformation')" class="action" id="info-button" @mouseenter="mouseEnterButton" @mouseleave="mouseLeaveButton">
        <info-icon size="1.5x" class="custom-class"></info-icon>
      </button>
      <div class="information" :style="infoStyle" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <h3>{{ $t('settings.userInformation') }}</h3>
          <x-icon @click="isShow = false" size="1.5x" class="custom-class"></x-icon>
        </div>
        <div class="column">
          <user-icon size="1.5x" class="custom-class"></user-icon>
          <p class="user" :title="name">{{ name }}</p>
        </div>
        <div class="column date">
          <calendar-icon size="1.5x" class="custom-class"></calendar-icon>
          <p>{{ humanTime(ctime) }}</p>
        </div>
        <div v-if="name === emailAdmin" class="column revoke">
          <span class="admin">{{ $t('settings.administrator') }}</span>
        </div>
        <div v-else-if="isAdmin" class="column revoke">
          <button class="button button-create" :title="$t('settings.revokeAccess')" @click="revocarAcceso(handle)">
            <span>{{ $t('settings.revokeAccess') }}</span>
          </button>

          <select v-on:change="changePermissions" v-model="permissions">
            <option :value=0>{{ $t('settings.editor') }}</option>
            <option :value=1>{{ $t('settings.reader') }}</option>
          </select>
        </div>
        <div v-else-if="!isAdmin" class="column revoke">
          <button class="button button-create" :title="$t('settings.revokeAccessAccount')" @click="revocarAccesoCuenta()">
            <span>{{ $t('settings.revokeAccessAccount') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { UserIcon, CalendarIcon, XIcon, InfoIcon } from 'vue-feather-icons';
import { files as ibbapi } from '@/api';

export default {
  name: 'access-concessions',
  components: {
    UserIcon,
    CalendarIcon,
    XIcon,
    InfoIcon
  },
  data: function () {
    return {
      emailAdmin: '',
      isAdmin: false,
      isShow: false,
      permissions: '',
      isPopUp: false,
      isButton: false
    };
  },
  props: ['name', 'ctime', 'handle', 'accesslevel'],
  async mounted () {
    this.permissions = this.accesslevel;

    try {
      let action = await ibbapi.getAccountInfo();
      this.emailAdmin = action.email;
    } catch (e) {
      this.$showError(e);
    }

    try {
      let action = await ibbapi.getUserInfo();
      if (action.userInfo.email === this.emailAdmin) {
        this.isAdmin = true;
      }
    } catch (e) {
      this.$showError(e);
    }

    window.addEventListener('click', this.click);
  },
  beforeDestroy () {
    window.removeEventListener('click', this.click);
  },
  computed: {
    infoStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    isMobile: function () {
      return window.innerWidth <= 768;
    },
    humanTime: function (time) {
      if (time === 0) {
        return '-';
      } else {
        return moment(time * 1000).format('DD/MM/YYYY');
      }
    },
    revocarAcceso(handle) {
      this.$emit('revocar-acceso', handle);
    },
    revocarAccesoCuenta() {
      this.$emit('revocar-cuenta');
    },
    async changePermissions () {
      let action = await ibb.setAccessLevel(this.handle, this.permissions);
      if (!action.error.type) {
        this.$showSuccess(this.$t('settings.changePermissionsSucess'));
      }
    },
    mouseEnter() {
      this.isPopUp = true;
    },
    mouseLeave() {
      this.isPopUp = false;
    },
    mouseEnterButton() {
      this.isButton = true;
    },
    mouseLeaveButton() {
      this.isButton = false;
    },
    click() {
      if (!this.isPopUp && !this.isButton) {
        this.isShow = false;
      }
    }
  }
};
</script>